import React from 'react';
import LoseBase from '../components/base/lose-base';

const TourneysComponentsFormRulesPartLose = () => {
  return <LoseBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartLose;
